module.exports = __webpack_public_path__ + "static/media/badge_red.0159a193.svg";